import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Grid} from '@daedalus/atlas/helpers/Grid'
import {Text} from '@daedalus/atlas/Text'
import {TaxationAndNightlyPriceMessage} from '@daedalus/shared/src/search/TaxationAndNightlyPriceMessage'

export const RoomName = styled(Text)(
  ({theme}) => css`
    max-width: 400px;
    color: ${theme.colors.content.neutral.c950};
    margin-bottom: ${theme.layout.spacing.s100}px;
    &:first-letter {
      text-transform: capitalize;
    }
  `
)

export const OfferCtaWrapper = styled.div(
  ({theme}) => css`
    margin-top: ${theme.layout.spacing.s300}px;
    white-space: nowrap;
  `
)

export const LogoWrapper = styled.div(
  ({theme}) => css`
    margin-top: ${theme.layout.spacing.s300}px;
    margin-bottom: ${theme.layout.spacing.s200}px;
  `
)

export const CtaPriceWrapper = styled(Grid)(
  ({theme}) => css`
    text-align: right;
    margin-top: ${theme.layout.spacing.s600}px;
    margin-left: ${theme.layout.spacing.s600}px;
    flex-basis: auto;
    align-self: flex-start;
  `
)

export const OfferDetailsWrapper = styled('div')(
  ({theme}) => css`
    width: 100%;
    padding: ${theme.layout.spacing.s400}px;
    border-top: 1px solid ${theme.colors.border.brand.c100};
    border-bottom: 1px solid ${theme.colors.border.brand.c100};
    background-color: ${theme.colors.background.brand.c050};
  `
)

export const CtaPriceContentContainer = styled.div(
  ({theme}) => css`
    padding-right: ${theme.layout.spacing.s200}px;
  `
)

export const LabelContainer = styled.div(
  ({theme}) => css`
    margin-left: -${theme.layout.spacing.s200}px;
  `
)

export const ChevronWrapper = styled.div`
  /* @mirror */
`

export const StyledTaxationAndNightlyPriceMessage = styled(
  TaxationAndNightlyPriceMessage
)`
  white-space: nowrap;
`
